const DefaultVariant = require('./default')
const ProductionVariant = require('./production')

const vgsForm = {
  [DefaultVariant.name]: DefaultVariant,
  [ProductionVariant.name]: ProductionVariant,
}

module.exports = {
  ['vgs-form']: vgsForm
}